package com.eladfinish.bible.contest.text

import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf

// TODO: consider renaming to RichText
data class SpannableStringKMP(
    val charSequence: CharSequence,
    val spannedRangeList: ImmutableList<SpannedRange>,
) {
    companion object {
        val empty = SpannableStringKMP(
            charSequence = "",
            spannedRangeList = persistentListOf(),
        )

        fun fromString(text: String): SpannableStringKMP =
            SpannableStringKMP(
                charSequence = text,
                spannedRangeList = persistentListOf(),
            )
    }
}
